
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"20","viewBox":"0 0 16 16"}, attrs),
              ...rest,
            },
            children.concat([_c('rect',{attrs:{"width":"12","height":"2","x":"2","y":"7","rx":"1"}}),_c('rect',{attrs:{"width":"2","height":"12","x":"7","y":"2","rx":"1"}})])
          )
        }
      }
    